import styled from 'styled-components';
import { theme, toRem } from '../../styles';

export const StyledPicture = styled.picture`
  .image {
    overflow: hidden;
    object-fit: cover;
    width: 100%;
    &.object-fit-initial {
      object-fit: initial;
    }
    @media ${theme.mediaQuery.allMobiles} {
      &.mobile-height {
        min-height: ${toRem(375)};
      }
    }
  }
  .lazy {
    filter: blur(0);
  }
  .brand-elevation-img {
    height: 100%;
  }
`;
